import { Box } from '@mui/material';
import React from 'react';
import Plot from 'react-plotly.js';
import { basePlotConfig, useChartTheme } from '../overview/plotTheme';

const HourlyPlot = ({
  tsSoc,
  tsTemperature
}) => {
  const hasTemperature = tsTemperature?.y?.some((v) => v != null);
  const { colors, baseLayout: makeLayout, themeTrace } = useChartTheme();
  const baseLayout = makeLayout("SOC (%)");

  return (
    <Box sx={{ width: "100%", height: "100%" }}>
      <Plot
        data={(hasTemperature ? [tsSoc, tsTemperature] : [tsSoc]).map(themeTrace)}
        layout={{
          ...baseLayout,
          legend: { ...baseLayout.legend, x: 0, xanchor: "left" },
          yaxis: { ...baseLayout.yaxis, range: [0, 100] },
          yaxis2: {
            title: { text: "Max cell temp. (°C)", font: { size: 12, color: colors.text }, standoff: 8 },
            overlaying: "y",
            side: "right",
            visible: hasTemperature,
            showgrid: false,
            zeroline: false,
            automargin: true,
          },
        }}
        config={basePlotConfig}
        useResizeHandler={true}
        style={{ width: "100%", height: "100%" }}
      />
    </Box>
  )
}

export default HourlyPlot;
